import { put } from "redux-saga/effects";
import { FormsService } from "../../../services/forms";
import { GetSquareSubsRequestActionType } from "../types";
import { getSquareSubsSuccess } from "../actionCreators";

export function* getSquareSubPlansSaga({ payload }: GetSquareSubsRequestActionType) {
    try {
        const {
            data: { data },
        } = yield FormsService.getSquareSubscriptions(payload.settingsId);
        yield put(getSquareSubsSuccess({ data }));
    } catch (e) {
        console.log("Error in getSquareSubPlansSaga", e);
    }
}
